// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"27d47473","498":"dd51f93d","598":"83f55a90"}[chunkId] + ".chunk.js";
};